const SET_ACTIVE_PRODUCT = 'classpass/products/SET_ACTIVE_PRODUCT';

export const setActiveProduct = (productKey, productData) => ({ type: SET_ACTIVE_PRODUCT, productKey, productData });
export const selectActiveProduct = state => state.features.products.activeProduct;

const initialState = {
  activeProduct: {
    key: null,
    data: null,
  },
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_ACTIVE_PRODUCT:
      return {
        ...state,
        activeProduct: {
          key: action.productKey,
          data: action.productData,
        },
      };
    default:
      return state;
  }
}
